import React from "react"

export const ProductImage = ( { product } ) => {
    return (
        <div className="product-image">
            <img src={product.page_image_main} alt={product.item_description}></img>
        </div>
    )
}


export default ProductImage